<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="7">
          <v-card outlined class="pa-4">
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="8" class="text-h6">Podaci o maturi</v-col>
            </v-row>
            <template v-if="graduationInfo !== null">
              <v-row v-for="(val, key, index) in graduationInfo" :key="index">
                <v-col class="text-right font-weight-light">{{ key }}:</v-col>
                <v-col cols="8">{{ val ? val : "-" }}</v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row>
                <v-col class="text-center font-weight-light">Matura nije kreirana</v-col>
              </v-row>
            </template>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-btn
              block
              depressed
              class="text-none"
              color="primary"
              height="44"
              @click="openEdit"
              v-if="!graduation || graduation && !graduation.official"
          >
            Uredi podatke
          </v-btn>
          <v-btn
              block
              depressed
              class="text-none my-3"
              color="primary"
              height="44"
              @click="openEdit2"
              v-if="graduation && !graduation.official"
          >
            Dodatna polja
          </v-btn>
          <v-btn
              block
              depressed
              class="text-none my-3"
              color="primary"
              height="44"
              v-if="graduation"
              @click="loadDiploma(graduation)"
          >
            Pregled
          </v-btn>
          <v-btn
              block
              depressed
              class="text-none my-3"
              color="error"
              height="44"
              v-if="graduation && !graduation.official"
              @click="lockDialog = true"
          >
            Potvrdi
          </v-btn>
          <v-btn
              block
              depressed
              class="text-none my-3"
              height="44"
              v-if="graduation && graduation.official"
              @click="demandDialog = true"
          >
            Pošalji zahtjev za otključavanjem mature
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="800" @click:outside="closeEdit">
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>Uredite podatke</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="closeEdit" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container class="pt-6">
          <v-row>
            <v-col>
              <ValidationProvider
                  :name="item.name"
                  :rules="item.rules"
                  mode="eager"
                  ref="provider"
                  v-bind:key="item.name"
                  v-for="item in items"
              >
                <div slot-scope="{ errors }">
                  <v-row no-gutters>
                    <!--Label for the form-->
                    <v-col
                        cols="12"
                        md="3"
                        style="height: 44px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-2"
                      >
                        <span
                            class="font-weight-bold text--primary"
                            :style="{
                            color:
                              errors.length > 0
                                ? 'rgb(236 29 36) !important'
                                : '',
                            opacity: 0.8,
                            marginRight: '8px',
                          }"
                        >{{ item.title }}:</span
                        >
                      </div>
                    </v-col>
                    <!-- Text field -->
                    <v-col cols="12" md="9">
                      <v-text-field
                          dense
                          :name="item.name"
                          outlined
                          :type="item.type"
                          :placeholder="
                          item.rules && item.rules.includes('required')
                            ? 'Obavezno...'
                            : ''
                        "
                          :prepend-icon="item.icon"
                          v-if="item.tag === 'input'"
                          v-model="form[item.name]"
                      >
                      </v-text-field>
                      <v-autocomplete
                          outlined
                          dense
                          :placeholder="item.rules ? 'Obavezno..' : ''"
                          :items="item.source"
                          :name="item.name"
                          :prepend-icon="item.icon"
                          :item-text="item.text"
                          :item-value="item.value"
                          v-if="item.tag === 'select'"
                          v-model="form[item.name]"
                      >
                      </v-autocomplete>

                      <!-- Date picker -->
                      <v-menu
                          v-model="item.model"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                          v-if="item.tag === 'date'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              outlined
                              dense
                              v-model="form[item.name]"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="form[item.name]">
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </div>
              </ValidationProvider>
              <v-row no-gutters>
                <!--Label for the form-->
                <v-col
                    cols="12"
                    md="3"
                    style="height: 44px"
                    class="d-flex justify-end"
                >
                  <div class="d-flex align-center justify-end text-right mb-2">
                    <span
                        class="font-weight-bold text--primary"
                        :style="{
                        opacity: 0.8,
                        marginRight: '8px',
                      }"
                    >{{ subject.title }}:</span
                    >
                  </div>
                </v-col>
                <v-col cols="10" md="7">
                  <v-autocomplete
                      outlined
                      dense
                      multiple
                      chips
                      :disabled="form.is_released"
                      :placeholder="subject.rules ? 'Obavezno..' : ''"
                      :items="availableGraduationSubjects"
                      :name="subject.name"
                      :prepend-icon="subject.icon"
                      :item-text="subject.text"
                      return-object
                      v-if="subject.tag === 'select'"
                      v-model="form.graduation_subjects"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-checkbox v-model="form.is_released" label="Oslobođen polaganja"></v-checkbox>
                </v-col>
              </v-row>
              <v-divider class="my-4"></v-divider>
              <v-row no-gutters class="my-4" v-if="!form.is_released">
                <v-col cols="12" offset="2">
                  <v-data-table
                      :headers="headers"
                      :items="graduationSubjects"
                      hide-default-footer
                      disable-sort
                      v-show="form.graduation_subjects.length>0"
                  >
                    <template
                        v-if="areNumericalGrades"
                        v-slot:[`item.graduation_grade`]="{ item }"
                    >
                      <v-form :ref="`form_${item.id}`">
                        <v-autocomplete
                            :items="grades"
                            item-text="text"
                            item-value="value"
                            outlined
                            dense
                            v-model="item.final_grade"
                            hide-details
                            clearable
                            style="width: 180px"
                        >
                        </v-autocomplete>
                      </v-form>
                    </template>
                    <template
                        v-else
                        v-slot:[`item.pivot.descriptive_grade_semester`]="{
                        item,
                      }"
                    >
                      <v-form :ref="`form_${item.id}`" v-model="valid">
                        <v-textarea
                            outlined
                            dense
                            v-model="item.pivot.descriptive_grade_semester"
                            auto-grow
                            counter="150"
                            :rules="[
                            (v) =>
                              (v || '').length <= 150 ||
                              'Maksimalno 150 znakova',
                          ]"
                            rows="1"
                        >
                        </v-textarea>
                      </v-form>
                    </template>
                    <template v-slot:no-data>
                      <span>
                        Za tražene pojmove nema rezultata pretrage.
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row
              >
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeEdit" class="text-none" depressed large outlined>
            Odustani
          </v-btn>
          <v-btn
              color="primary"
              class="text-none"
              depressed
              large
              @click="updateGraduation"
          >
            Potvrdi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog2" width="1000" @click:outside="closeEdit2">
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>Uredite dodatna polja</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="closeEdit2" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container class="pt-6">
          <v-row>
            <v-col>
              <!--       Posebna polja Posavina       -->
              <v-row no-gutters class="my-4">
                <!--Label for the form-->
                <v-col
                    cols="12"
                    md="3"
                    style="height: 44px"
                    class="d-flex justify-end"
                >
                  <div class="d-flex align-center justify-end text-right mb-2">
                    <span
                        class="font-weight-bold text--primary"
                        :style="{
                        opacity: 0.8,
                        marginRight: '8px',
                      }"
                    >{{ 'Datum upisa u obrazovni program' }}:</span
                    >
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <!-- Date picker -->
                  <v-menu
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          outlined
                          dense
                          v-model="form.educational_program_enrollment_date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.educational_program_enrollment_date">
                    </v-date-picker>
                  </v-menu>

                </v-col>
              </v-row>
              <v-row no-gutters class="my-4">
                <!--Label for the form-->
                <v-col
                    cols="12"
                    md="3"
                    style="height: 44px"
                    class="d-flex justify-end"
                >
                  <div class="d-flex align-center justify-end text-right mb-2">
                    <span
                        class="font-weight-bold text--primary"
                        :style="{
                        opacity: 0.8,
                        marginRight: '8px',
                      }"
                    >{{ 'Naziv završene osnovne škole' }}:</span
                    >
                  </div>
                </v-col>
                <v-col cols="10" md="7">
                  <v-text-field
                      v-if="schoolNotInList"
                      outlined
                      dense
                      :placeholder="subject.rules ? 'Obavezno..' : ''"
                      v-model="form.completed_primary_school_name"
                  >
                  </v-text-field>
                  <v-autocomplete
                      v-else
                      outlined
                      dense
                      :placeholder="subject.rules ? 'Obavezno..' : ''"
                      :items="elementarySchools"
                      item-text="name"
                      item-value="name"
                      v-model="form.completed_primary_school_name"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-checkbox label="Škola nije na popisu" v-model="schoolNotInList"></v-checkbox>
                </v-col>
              </v-row>
              <v-row no-gutters class="my-4">
                <!--Label for the form-->
                <v-col
                    cols="12"
                    md="3"
                    style="height: 44px"
                    class="d-flex justify-end"
                >
                  <div class="d-flex align-center justify-end text-right mb-2">
                    <span
                        class="font-weight-bold text--primary"
                        :style="{
                        opacity: 0.8,
                        marginRight: '8px',
                      }"
                    >{{ 'Broj svjedodžbe' }}:</span
                    >
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                      outlined
                      dense
                      :placeholder="subject.rules ? 'Obavezno..' : ''"
                      v-model="form.primary_school_diploma_number"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="my-4">
                <!--Label for the form-->
                <v-col
                    cols="12"
                    md="3"
                    style="height: 44px"
                    class="d-flex justify-end"
                >
                  <div class="d-flex align-center justify-end text-right mb-2">
                    <span
                        class="font-weight-bold text--primary"
                        :style="{
                        opacity: 0.8,
                        marginRight: '8px',
                      }"
                    >{{ 'Datum izdavanja svjedodžbe' }}:</span
                    >
                  </div>
                </v-col>
                <v-col cols="12" md="9">
                  <!-- Date picker -->
                  <v-menu
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          outlined
                          dense
                          v-model="form.primary_school_diploma_date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.primary_school_diploma_date">
                    </v-date-picker>
                  </v-menu>

                </v-col>

              </v-row>

            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeEdit2" class="text-none" depressed large outlined>
            Odustani
          </v-btn>
          <v-btn
              color="primary"
              class="text-none"
              depressed
              large
              @click="updateGraduation"
          >
            Potvrdi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="lockDialog"
        width="500"
        @click:outside="lockDialog = false"
    >
      <v-card>
        <v-card-title primary-title> Jeste li sigurni?</v-card-title>

        <v-card-text class="pt-5">
          Jeste li sigurni da želite potvrditi? <br/>
          <span class="font-weight-bold">Upozorenje:</span>
          Kada potvrdite dokument više nećete imati mogućnost uređivanja.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="lockDialog = false"
              class="text-none"
              depressed
              large
              outlined
          >Odustani
          </v-btn
          >
          <v-btn
              color="error"
              @click="generateOfficialGraduation"
              class="text-none"
              depressed
              large
          >Potvrdi
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="demandDialog"
        width="400"
        @click:outside="demandDialog = false"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>Pošalji zahtjev</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="demandDialog = false" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="mt-6">
          <v-row>
            <v-col cols="12">
              <v-textarea
                  outlined
                  dense
                  auto-grow
                  v-model="demandReason"
                  rows="3"
                  label="Razlog"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="demandDialog = false"
              class="text-none"
              depressed
              large
              outlined
          >Odustani
          </v-btn
          >
          <v-btn
              color="primary"
              class="text-none"
              @click="sendDemand"
              depressed
              large
          >Potvrdi
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import {ValidationProvider} from "vee-validate";
import ApiV2 from "@/services/ApiV2";
import {serverBus} from "@/main";

export default {
  components: {
    ValidationProvider,
  },
  name: "StudentGraduation",

  props: {
    department: {
      type: Object
    }
  },

  async created() {
    this.areNumericalGrades =
        localStorage.getItem("are_numerical_grades") === "true";
    await this.getGraduationSubjects()
    await this.getGraduation()
    await this.getGraduationDocketNumber()
    await this.getElementarySchools()
  },

  computed: {
    avg() {
      let avrg = 0.00
      let sum = 0
      for (let i = 0; i < this.graduation?.graduation_subjects.length; i++) {
        sum += parseFloat(this.graduation?.graduation_subjects[i].final_grade);
      }
      avrg = sum / this.graduation?.graduation_subjects.length
      return avrg.toFixed(2)
    },
    graduationSubjects() {
      return this.form.graduation_subjects;
    },
    enrolledStudent() {
      return this.$store.getters.getEnrolledStudent;
    },
    headers() {
      return [
        {text: "Predmet", value: "title"},
        {text: "Zaključna ocjena", value: "graduation_grade"},
      ];
    },
  },

  data() {
    return {
      dialog: false,
      dialog2: false,
      lockDialog: false,
      schoolNotInList: false,
      studentDocketNumber: null,
      form: {
        graduation_work_name: '',
        date_from: '',
        date_to: '',
        graduation_subjects: []
      },
      elementarySchools: [],
      graduationInfo: null,
      graduation: null,
      graduationId: null,
      areNumericalGrades: true,
      demandDialog: false,
      demandReason: "",
      subjects: [1, 2],
      grades: [
        {value: 5, text: "odličan (5)"},
        {value: 4, text: "vrlo dobar (4)"},
        {value: 3, text: "dobar (3)"},
        {value: 2, text: "dovoljan (2)"},
        {value: 1, text: "nedovoljan (1)"},
        {value: 0, text: "neocijenjen"},
        {value: -1, text: "obavljena"},
      ],
      availableGraduationSubjects: [],
      items: [
        {
          data: "graduation_work_name",
          name: "graduation_work_name",
          options: "",
          rules: "",
          source: [],
          tag: "input",
          type: "text",
          title: "Naziv maturalnog rada",
        },
        {
          data: "date_end",
          name: "date_end",
          options: "",
          rules: "",
          source: [],
          tag: "date",
          type: "text",
          title: "Datum završetka završnog razreda",
        },
        {
          data: "date_from",
          name: "date_from",
          options: "",
          rules: "",
          tag: "date",
          title: "Polagao od",
          type: "text",
          model: false,
        },
        {
          data: "date_to",
          name: "date_to",
          options: "",
          rules: "",
          tag: "date",
          title: "Polagao do",
          type: "text",
          model: false,
        },
        {
          data: "docket_number",
          name: "docket_number",
          options: "",
          rules: "",
          tag: "input",
          title: "Urudžbeni broj",
          type: "text",
          model: false,
        },
      ],
      subject: {
        data: "diploma_template_id",
        name: "diploma_template_id",
        options: "",
        rules: "",
        source: [],
        text: "title",
        value: "id",
        tag: "select",
        type: "text",
        title: "Predmeti",
      },
    };
  },
  methods: {
    sendDemand() {
      const body = {
        demandable_type: "Graduation",
        demandable_id: this.graduation.id,
        reason: this.demandReason,
        school_id: parseInt(localStorage.getItem('school_id')),
        column_name: "official",
      };

      ApiV2.post("demands", body)
          .then(() => {
            this.demandDialog = false;
            serverBus.$emit("show-snackbar", true);
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    openEdit() {
      if (this.graduation?.date_end === null) {
        this.graduation.date_end = this.department?.date_end
      }


      Object.assign(this.form, this.graduation);
      let gradSubjects = []
      let hrvatski = this.availableGraduationSubjects.filter(x => x.title === 'Hrvatski jezik')[0]
      let matura = this.availableGraduationSubjects.filter(x => x.title === 'Maturalni rad')[0]
      let i = 0;
      if (!this.graduation) {
        if (matura) {
          i++;
          gradSubjects.push({
            subject_id: matura.id,
            title: matura.title,
            sequence: i,
          })

        }
        if (hrvatski) {
          i++;
          gradSubjects.push({
            subject_id: hrvatski.id,
            title: hrvatski.title,
            sequence: i,
          })
        }
      }

      this.form.graduation_subjects.forEach(subject => {
        i++;
        gradSubjects.push({
          id: subject.id,
          subject_id: subject.subject.id,
          title: subject.subject.title,
          final_grade: subject.final_grade,
          sequence: i
        })
      })
      this.form.graduation_subjects = gradSubjects
      this.getGraduationDocketNumber()
      this.dialog = true;
    },
    openEdit2() {
      Object.assign(this.form, this.graduation);
      let gradSubjects = []
      this.form.graduation_subjects.forEach((subject, index) => {
        gradSubjects.push({
          id: subject.id,
          subject_id: subject.subject.id,
          title: subject.subject.title,
          final_grade: subject.final_grade,
          sequence: index+1
        })
      })
      this.form.graduation_subjects = gradSubjects
      this.dialog2 = true;
    },

    async getElementarySchools() {
      let {data} = await ApiV2.get('schools/basic_info', {
        params: {
          perPage: -1,
          filter: {
            type: 'primary'
          }
        }
      })
      this.elementarySchools = data.data
    },

    closeEdit() {
      this.dialog = false;
      this.form = {
        graduation_work_name: '',
        date_from: '',
        date_to: '',
        graduation_subjects: []

      };
    },
    closeEdit2() {
      this.dialog2 = false;
      this.form = {
        graduation_work_name: '',
        date_from: '',
        date_to: '',
        graduation_subjects: []

      };
    },

    async generateOfficialGraduation() {

      let {data} = await ApiV2.post(`graduations/${this.graduation.id}/official`)
      if (data) {
        this.graduation.official = true
      }
      this.lockDialog = false;

    },

    loadDiploma(diploma) {
      let baseUrl = process.env.VUE_APP_SKOLE_API_URL;
      // let magla = '9b519e36-3124-43ac-8b88-bdd3260e0b48'

      baseUrl = baseUrl + "v2/";
      // if (this.graduation.is_released){
      //   magla = '840bda53-918f-4eb9-80fc-ac79b2f361f0'
      // }
      // diploma.uuid = magla
      window.open(`${baseUrl}files/${diploma.graduation_file?.uuid}`, "_blank");
    },
    async getGraduationDocketNumber() {
      let {data} = await ApiV2.get(`graduations/calculate_docket_number/${this.enrolledStudent?.id}`)

      this.form.docket_number = data

    },
    async getGraduationSubjects() {
      let {data} = await ApiV2.get(`graduations/available_graduation_subjects/${this.$route?.params?.odjeljenje_id}`)
      this.availableGraduationSubjects = data
    },
    async getGraduation() {
      let {data} = await ApiV2.get('graduations', {
        params: {
          filter: {
            department_enrollment_id: this.enrolledStudent?.id
          },
          with: ['graduationSubjects.subject', 'graduationFile']
        }
      })
      if (data.data.length > 0) {
        this.graduation = data.data[0]
        this.optimizeData(this.graduation)
      }
    },
    async updateGraduation() {
      if (this.graduation === null) {
        await this.saveGraduation()
        return
      }
      let avrg = 0.00
      let sum = 0
      if (this.form.is_released) {
        this.form.graduation_subjects = []
        this.form.final_success = 5
      } else {
        this.form.graduation_subjects.forEach((subject, index) => {
          sum += parseFloat(subject.final_grade);
          subject.sequence = index+1;
          if (!subject.subject_id) {
            subject.subject_id = subject.id
            delete subject.id
          }
        })

        avrg = sum / this.form.graduation_subjects.length
        this.form.final_success = parseFloat(avrg.toFixed(2));


      }
      if (this.form.final_success === null || isNaN(this.form.final_success)){
        this.form.final_success = 1;
      }


      await ApiV2.put(`graduations/${this.graduation.id}`, this.form)
          .then(() => {
            this.closeEdit();
            this.closeEdit2();
            this.getGraduation();
            serverBus.$emit('show-snackbar', true);
          })
          .catch((error) => {
            if (error.response.status == 422) {
              for (let key in error.response.data.errors) {
                serverBus.$emit(
                    "show-snackbar",
                    false,
                    error.response.data.errors[key][0]
                );
              }
            } else if (error.response.status == 400) {
              serverBus.$emit(
                  "show-snackbar",
                  false,
                  error.response.data.message
              );
            } else {
              serverBus.$emit("show-snackbar", false);
            }
          });
    },
    async saveGraduation() {
      let avrg = 0.00
      let sum = 0

      if (this.form.is_released) {
        this.form.graduation_subjects = []
        this.form.final_success = 5

      } else {

        this.form.graduation_subjects.forEach((subject, index) => {
          sum += parseFloat(subject.final_grade);
          subject.sequence = index+1;
          if (!subject.subject_id) {

            subject.subject_id = subject.id
            delete subject.id

          }

        })

        avrg = sum / this.form.graduation_subjects.length
        this.form.final_success = parseFloat(avrg.toFixed(2));

      }

      if (this.form.final_success === null || isNaN(this.form.final_success)){
        this.form.final_success = 1;
      }


      this.form.department_enrollment_id = this.enrolledStudent?.id
      await ApiV2.post(`graduations`, this.form)
          .then(() => {
            this.closeEdit();
            this.getGraduation();
            serverBus.$emit('show-snackbar', true);
          })
          .catch((error) => {
            if (error.response.status == 422) {
              for (let key in error.response.data.errors) {
                serverBus.$emit(
                    "show-snackbar",
                    false,
                    error.response.data.errors[key][0]
                );
              }
            } else if (error.response.status == 400) {
              serverBus.$emit(
                  "show-snackbar",
                  false,
                  error.response.data.message
              );
            } else {
              serverBus.$emit("show-snackbar", false);
            }
          });
    },
    optimizeData(data) {
      this.graduationInfo = {
        "Naziv maturalnog rada": data.graduation_work_name,
        "Polagao od": this.$parseDate(data.date_from),
        "Polagao do": this.$parseDate(data.date_to),
      };
      if (data.graduation_subjects.length > 0) {
        for (let i = 0; i < data.graduation_subjects.length; i++) {
          this.graduationInfo[data.graduation_subjects[i].subject?.title] =
              `${this.gradeTextTerm(data.graduation_subjects[i].final_grade)} (${data.graduation_subjects[i].final_grade})`
        }
        this.graduationInfo['Prosjek'] = `${this.gradeTextTerm(this.avg)} (${this.avg})`
      } else if (data.is_released) {
        this.graduationInfo["Status"] = 'Učenik je oslobođen polaganja mature.'
      }
    },
    gradeTextTerm(num) {
      if (num < 1.50) {
        return 'Nedovoljan'
      }
      if (1.50 <= num && num < 2.50) {
        return 'Dovoljan'
      }
      if (2.50 <= num && num < 3.50) {
        return 'Dobar'
      }
      if (3.50 <= num && num < 4.50) {
        return 'Vrlo dobar'
      }
      if (4.50 <= num) {
        return 'Odličan'
      }
    }
  },
};
</script>

<style scoped></style>
